import * as Yup from "yup";

export default Yup.object().shape({
  process: Yup.string().required("Field is required"),
});
